import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import { ProductMappingService } from '../../../../api/product-mapping.api';
import { LoadOptions } from '../../../../shared/models/shared.model';

@Component({
  selector: 'app-transaction-detail',
  templateUrl: './transaction-detail.component.html',
})
export class TransactionDetailComponent implements OnInit, AfterViewInit {
  @Input() key: any;
  transactionDetailData: any = {};
  constructor(private productMappingService: ProductMappingService) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
	this.transactionDetailData = new CustomStore({
		key: 'SourceSalonId',
		load: (loadOptions: any) => {
		return this.productMappingService.getUnifiedTransactionsForServiceAndProductMapping(loadOptions, this.key)
			.toPromise()
			.then((data: any) => {
			return {
				data: data.data,
				totalCount: data.totalCount,
				summary: data.summary,
				groupCount: data.groupCount
			};
			})
			.catch(error => { throw new Error('Data Loading Error'); });
		}
	});
  }

}
